<template>
	<div style="background-color: #eee">

		<!--<div-->
		<!--	v-if="computedAmIAdmin && computedClienteClickdayIt"-->
		<!--	class="d-flex align-center justify-end mb-6"-->
		<!--&gt;-->
		<!--		&lt;!&ndash;@success="handleSuccess"&ndash;&gt;-->
		<!--		&lt;!&ndash;@error="handleError"&ndash;&gt;-->
		<!--		<v-btn-->
		<!--			small-->
		<!--			rounded-->
		<!--			depressed-->
		<!--			style="text-transform:none; color:white;"-->
		<!--			:color="scdOrange"-->
		<!--			v-if="!isLoadingClassifica"-->
		<!--		>-->
		<!--			<vue-blob-json-csv-->
		<!--				file-type="csv"-->
		<!--				file-name="classifica"-->
		<!--				:data="classifica"-->
		<!--				:fields="[-->
		<!--					'posizione_classifica',-->
		<!--					'id_cliccatore',-->
		<!--					'codice_cliccatore',-->
		<!--					'nome_squadra',-->
		<!--					'clickday_partecipati',-->
		<!--					'clickday_vinti',-->
		<!--					'clickday_persi',-->
		<!--					'gameday_partecipati',-->
		<!--					'gameday_vinti',-->
		<!--					'gameday_persi',-->
		<!--					'punti'-->
		<!--				]"-->
		<!--			>-->
		<!--				Scarica csv-->
		<!--			</vue-blob-json-csv>-->
		<!--		</v-btn>-->
		<!--</div>-->

		<v-data-table
			:headers="headers"
			:items="classifica"
			loading-text="In caricamento.."
			:loading="isLoadingClassifica"
			no-data-text="Nessun cliccatore"
			:footer-props="{
			'items-per-page-options':[50, 100, 200, 500, -1],
			'items-per-page-text': 'Cliccatori per pagina'
		}"
			style="background-color: white; border-radius: 0"
			class="classifica-data-table"
			dense
			fixed-header
			height="calc(100vh - 220px)"
			:options="{
				itemsPerPage: -1,
			}"
		>
			<template slot="item" slot-scope="props">
				<tr :style="`color: ${scdColor}; ${ props.item.riga_da_evidenziare ? 'background-color: rgba(230, 144, 28, 0.5);' : null }`">
					<td class="font-weight-medium">{{ props.item.posizione_classifica }}°</td>
					<td class="font-weight-medium">{{ props.item.codice_cliccatore }}</td>
					<td class="font-weight-medium">{{ props.item.nome_squadra }}</td>
					<td class="font-weight-medium">{{ props.item.clickday_partecipati }}</td>
					<td class="font-weight-medium">{{ props.item.clickday_vinti }}</td>
					<td class="font-weight-medium">{{ props.item.clickday_persi }}</td>
					<td class="font-weight-medium">{{ props.item.clickday_abbandonati }}</td>
					<td class="font-weight-medium">{{ props.item.clickday_non_assegnati }}</td>
					<td class="font-weight-medium">{{ props.item.gameday_partecipati }}</td>
					<td class="font-weight-medium">{{ props.item.gameday_vinti }}</td>
					<td class="font-weight-medium">{{ props.item.gameday_persi }}</td>
					<td class="font-weight-medium">{{ props.item.gameday_abbandonati }}</td>
					<td class="font-weight-medium">{{ props.item.punti }}</td>
				</tr>
			</template>
			
			<template
				v-if="amIAdminOrTeamleader"
				v-slot:footer.prepend
			>
				<div class="d-flex align-center">
					<v-select
						:items="[
							'Tutti',
							'Attivi',
							'Non attivi'
						]"
						v-model="qualiCliccatoriMostrare"
						label="Quali cliccatori mostrare"
						@change="getClassifica()"
						:disabled="isLoadingClassifica"
						hide-details
						dense
						outlined
						class="ml-3"
					></v-select>
				</div>
			</template>
		</v-data-table>
	</div>
</template>

<script>
export default {
	props: ['idCliccatore'],
	data() {
		return {
			showTooltip: false,
			isLoadingClassifica: false,
			headers: [
				{ text: 'Posizione', value: 'posizione_classifica' },
				{ text: 'Codice Cliccatore', value: 'codice_cliccatore' },
				{ text: 'Squadra', value: 'nome_squadra', width: '200px' },
				{ text: 'Clickday Partecipati', value: 'clickday_partecipati' },
				{ text: 'Clickday Vinti', value: 'clickday_vinti' },
				{ text: 'Clickday Persi', value: 'clickday_persi' },
				{ text: 'Clickday Abbandonati', value: 'clickday_abbandonati' },
				{ text: 'Clickday Non Assegnati', value: 'clickday_non_assegnati' },
				{ text: 'Gameday Partecipati', value: 'gameday_partecipati' },
				{ text: 'Gameday Vinti', value: 'gameday_vinti' },
				{ text: 'Gameday Persi', value: 'gameday_persi' },
				{ text: 'Gameday Abbandonati', value: 'gameday_abbandonati' },
				{ text: 'Punti', value: 'punti' },
			],
			classifica: [],
			
			qualiCliccatoriMostrare: 'Attivi'
		}
	},

	created() {
		this.getClassifica();
	},

	methods: {
		getClassifica() {
			this.isLoadingClassifica = true;
			const url = this.idCliccatore ? '/clickdayit/get_classifica_cliccatore/' + this.idCliccatore : '/clickdayit/get_classifica_cliccatore'
			axios.get(url, {
				params: {
					qualiCliccatoriMostrare: this.qualiCliccatoriMostrare
				}
			})
				.then(response => {
					this.classifica = response.data;
					// console.log(this.classifica)
				})
				.finally(() => {
					this.isLoadingClassifica = false;
				})
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .classifica-data-table {
	background-color:#eeeeee;
	color: #434343 !important;
	& .v-data-table-header tr th {
		border-bottom: none !important;
		color: #fff !important;
		background-color: #6d94cd;
		//text-align: center !important;

	}

	tbody tr:nth-of-type(even) {
		background-color: rgba(109, 148, 205, .15);
	}

	td {
		text-align: center;
		//font-weight: 500;
	}
}
</style>